module.exports = __webpack_public_path__ + "img/radar.5cab7fa9.png";